module.exports = __webpack_public_path__ + "img/seals_logo.29b21209.png";